import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAsync } from "./hooks";
import { api } from "./api";
import { Spinner } from "./components/Ui";
import { ConsentPage, ContactPage, HomePage, ProposalFormPage, ProposalsPage, SettingsPage, UserLayout } from "./pages/UserPages";
import { AdminLayout, BroadcastsAdminPage, ConversationsAdminPage, DashboardAdminPage, ProposalsAdminPage, UsersAdminPage } from "./pages/AdminPages";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { BrowserLoginPage } from "./pages/BrowserLoginPage";

export function App() {
  const location = useLocation();
  const auth = useAsync(() => api.me(), [location.pathname.startsWith("/admin")]);
  if (auth.loading) return <Spinner label="Подключаем Telegram…" />;

  const insideTelegram = Boolean(window.Telegram?.WebApp.initData);
  if (auth.error && location.pathname.startsWith("/admin") && !insideTelegram) return <AdminLoginPage onSuccess={auth.reload} />;
  if (auth.error && !insideTelegram) return <BrowserLoginPage onSuccess={auth.reload} />;
  if (auth.error) return <main className="fatal"><h1>Не удалось открыть приложение</h1><p>{auth.error}</p><p>Запустите мини‑апп из чата с ботом.</p></main>;
  if (!auth.data) return null;

  const { user, isAdmin } = auth.data;
  if (!user.consentedAt && !location.pathname.startsWith("/admin")) {
    return <ConsentPage user={user} onAccepted={auth.reload} />;
  }

  return (
    <Routes>
      <Route path="/" element={<UserLayout user={user} />}>
        <Route index element={<HomePage user={user} />} />
        <Route path="ideas" element={<ProposalsPage />} />
        <Route path="ideas/new" element={<ProposalFormPage />} />
        <Route path="ideas/:id/edit" element={<ProposalFormPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="settings" element={<SettingsPage user={user} onChanged={auth.reload} />} />
      </Route>
      <Route path="/admin" element={isAdmin ? <AdminLayout user={user} /> : <Navigate to="/" replace />}>
        <Route index element={<DashboardAdminPage />} />
        <Route path="messages" element={<ConversationsAdminPage />} />
        <Route path="ideas" element={<ProposalsAdminPage />} />
        <Route path="users" element={<UsersAdminPage />} />
        <Route path="broadcasts" element={<BroadcastsAdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
